import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
    h3: {
      fontSize: '3rem', // 54px
      '@media (max-width:960px)': {
        fontSize: '2rem', // 32px
      },
      '@media (max-width:600px)': {
        fontSize: '1.5rem', // 24px
      },
    },
    h4: {
      fontSize: '2rem', // 32px
      '@media (max-width:960px)': {
        fontSize: '1.5rem', // 24px
      },
      '@media (max-width:600px)': {
        fontSize: '1.125rem', // 18px
      },
    },
    body1: {
      fontSize: '1rem',
      fontWeight: '500'
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: '500'
    },
    subtitle2: {
      fontSize: '0.85rem',
      fontWeight: '500',
      '@media (max-width:600px)': {
        fontSize: '0.675rem',
        textAlign: 'left'
      },
    }
  },
  palette: {
    primary: {
      main: '#007bff',
    },
    secondary: {
      main: '#ff7043',
    },
    background: {
      default: '#f8fafc',
    },
    text: {
      primary: '#333',
    },
  },
  components: {
    MuiBox: {
      variants: [
        {
          props: { variant: 'layoutContainer' },
          style: {
            display: 'flex',
            height: '100vh',
            flexDirection: 'column',
          },
        },
        {
          props: { variant: 'header' },
          style: (theme) => ({
            padding: theme.spacing(1),
          }),
        },
      ],
    },
  },
});

export default theme;
